import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import moment from 'moment';
import Link from 'next/link';
import dayjs from 'dayjs';
import cn from 'classnames';
import HubspotForm from 'react-hubspot-form';

import { FORM_COMPLETE_ID } from 'react-scale/lib/zoominfo/formComplete';
import Spinner from 'react-scale/components/elements/spinner';

import styles from './form.module.css';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const setHiddenUTMFields = () => {
  let utmParams = {};
  try {
    utmParams = JSON.parse(window.localStorage.getItem('utm_params') || '{}');
    Object.keys(utmParams).forEach(property => {
      const utmField = document.querySelector(`input[name=${property}]`);
      if (utmField) {
        // @ts-ignore
        utmField.value = utmParams[property] ?? '';
      }
    });
  } catch (error) {
    // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
  }
};

const Form = ({ portalId, formId, date, downloadValidation, slug, hideModalAfterSubmit }) => {
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);

  const scriptLoad = async formID => {
    // @ts-ignore
    window._zi = {
      formId: FORM_COMPLETE_ID[formID],
      callbacks: { onMatch: onToggleFormField }
    };
    const zi = document.createElement('script');
    zi.type = 'text/javascript';
    zi.async = true;
    zi.src = 'https://ws-assets.zoominfo.com/formcomplete.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(zi, s);
  };

  const onToggleFormField = matchResult => {
    if (matchResult) {
      const fieldsNames = Object.keys(matchResult);
      for (let i = 0; i < fieldsNames.length; i += 1) {
        const name = fieldsNames[i];
        const inputField = document.querySelector(`input[name=${name}]`);

        if (matchResult[name] && name === 'company') {
          // @ts-ignore
          inputField.closest('.hs-form-field').style.display = 'none';
        } else if (!matchResult[name] && name === 'company') {
          // @ts-ignore
          inputField.closest('.hs-form-field').style.display = 'block';
        } else if (!matchResult[name] && name !== 'email') {
          const notEmailField = document.querySelector(`input[name=${name}]`);
          // @ts-ignore
          notEmailField.value = '';
        }
      }
    }
  };

  const handler = async event => {
    const { data, type, id, eventName } = event.data;
    if (type === 'hsFormCallback' && eventName === 'onFormSubmit') {
      if (id === formId) {
        const hutk = getCookie('hubspotutk');

        const body = {
          submittedAt: moment.utc().valueOf(),
          fields: [...data],
          context: {
            ...(hutk ? { hutk } : undefined),
            pageName: document.querySelector('title').text,
            pageUri: window.location.href
          }
        };

        const bodyStr = JSON.stringify(body);

        const result = await fetch(
          `https://api.hsforms.com/submissions/v3/integration/submit/4823527/${formId}`,
          {
            method: 'POST',
            body: bodyStr,
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        window.localStorage.setItem('hasregistered', slug);
        setTimeout(() => {
          hideModalAfterSubmit(true);
        }, 3000);

        if (result.ok && downloadValidation) {
          router.push(router.asPath);
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', handler);
    return () => {
      window.removeEventListener('message', handler);
    };
  }, []);

  useEffect(() => {
    if (
      !dayjs(date, 'YYYY-MM-DD HH:mm:ss').isBefore(dayjs(dayjs(), 'YYYY-MM-DD HH:mm:ss')) &&
      formId
    ) {
      setShowModal(true);
    }
  }, [date, formId]);

  return (
    <div className={styles.eventsForm} id="register">
      {dayjs(date, 'YYYY-MM-DD HH:mm:ss').isBefore(dayjs(dayjs(), 'YYYY-MM-DD HH:mm:ss')) ? (
        <div className="p-4 text-xl text-center text-black">
          You are seeing a past event, check out our <Link href="/events">Events page</Link> to
          catch up on future events
        </div>
      ) : (
        <>
          <div className="-mb-2 form">
            {showModal && (
              <HubspotForm
                portalId={portalId}
                formId={formId}
                cssRequired={''}
                target=".form"
                submitButtonClass={cn(
                  'font-medium text-base px-6 py-3 leading-relaxed inline-block rounded-full whitespace-nowrap cursor-pointer',
                  'bg-black',
                  'text-white',
                  'hs-button'
                )}
                onReady={async () => {
                  const form = document.querySelector(`.hs-form-${formId}`);
                  if (form) {
                    form.className += ' active';
                    scriptLoad(formId);
                  }

                  setHiddenUTMFields();
                }}
                loading={<Spinner size="lg" />}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Form;
